import { Component } from "react";

import * as React from "react";
import { Table } from "react-bootstrap";
import { IStateOption } from "../AssetsAndGrants";

interface IAssetAndGrantsTableProps {
  state?: IStateOption;
  county?: string;
  city?: string;
  zip?: string;
  stateLabel?: string;
  dateStart?: string;
}

interface IAssetAndGrantsTableState {
  state?: IStateOption;
  county?: string;
  city?: string;
  zip?: string;
  dateStart?: string;
  stateLabel?: string;
  data: any[];
  render: boolean;
}

export class AssetAndGrantsTable extends Component<
  IAssetAndGrantsTableProps,
  IAssetAndGrantsTableState
  > {
  _isMounted = false;

  state: IAssetAndGrantsTableState = {
    data: [],
    state: { id: "", stateLabel: "" },
    county: "",
    city: "",
    zip: "",
    dateStart: "",
    stateLabel: "",
    render: false,
  };

  componentWillMount() {
    this.setState({
      state: this.props.state,
      county: this.props.county,
      city: this.props.city,
      zip: this.props.zip,
      dateStart: this.props.dateStart,
      stateLabel: this.props.stateLabel,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.propsEquality(this.props, nextProps)) {
      this.setState({ render: !this.state.render }, () => {
        return nextProps;
      });
    }
    return this.props;
  }

  propsEquality(currentProps, nextProps) {
    return (
      nextProps.city === currentProps.city &&
      nextProps.state &&
      currentProps.state &&
      nextProps.state.id === currentProps.state.id &&
      nextProps.county === currentProps.county &&
      nextProps.zip === currentProps.zip &&
      nextProps.dateStart === currentProps.dateStart
    );
  }

  componentDidMount() {
    this._isMounted = true;
    this.getTableData(
      this.state.state,
      this.state.county,
      this.state.city,
      this.state.zip,
      this.state.dateStart,
      this.state.stateLabel
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.state !== this.props.state ||
      prevProps.county !== this.props.county ||
      prevProps.city !== this.props.city ||
      prevProps.zip !== this.props.zip ||
      prevProps.dateStart !== this.props.dateStart ||
      prevProps.stateLabel !== this.props.stateLabel
    ) {
      this.setState({ state: this.props.state }, () =>
        this.getTableData(
          this.props.state,
          this.props.county,
          this.props.city,
          this.props.zip,
          this.props.dateStart,
          this.props.stateLabel
        )
      );
    }
  }

  getTableData(state, county, city, zip, dateStart, stateLabel) {
    let defaultState = this.props.state || state || this.state.state;

    if (!defaultState) {
      defaultState = { id: "", stateLabel: "" };
    }

    // Bug: something is nesting a state object in
    // defaultState.id, so we need to check for that
    // and eventually find what is setting that
    if(typeof defaultState.id === 'object') {
      defaultState.id = defaultState.id.id;
    }

    const givTrendFilterBody = {
      action: "getOptimizedReturnData",
      request: {
        assetLevel: 0,
        state: defaultState.id,
        name: "",
        monthNumber: "12",
        city,
        county,
        zip,
        dateStart,
      },
    };
    fetch(
      "https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests",
      { method: "POST", body: JSON.stringify(givTrendFilterBody) }
    )
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, "&");
        text = text.replace(/\\/g, "");
        return JSON.parse(text);
      })
      .then((json) => {
        let data = [];

        let previousFMV = 0.0;
        let previousGrants = 0.0;

        // Helper function to get year and month from date
        const getYearMonth = (dateStr) => {
          const date = new Date(dateStr);
          return { year: date.getFullYear(), month: date.getMonth() + 1 };
        };

         // Step 1: Group data by year
         const groupedByYear = json.reduce((acc, item) => {
          const [monthStr, yearStr] = item.indexDate.split(", ");
          const monthParsed = new Date(Date.parse(`${monthStr} 1`)).getMonth(); // Get month index from month name

          // Create the date object
          const date = new Date(yearStr, monthParsed, 1); 
          const { year, month } = getYearMonth(date);
           if (!acc[year]) acc[year] = [];
           const newItem = { ...item, date };
          acc[year].push({ ...newItem, month });
          return acc;
         }, {});
        
        // Step 2: For each year, find the last month or latest available month
        const currentYear = new Date().getFullYear();
        const filteredData = Object.keys(groupedByYear).map((year) => {
          const items = groupedByYear[year];
          if (parseInt(year) === currentYear) {
              // For current year, get the latest available month
              return items.sort((a, b) => b.date - a.date)[0];
          } else {
              // For past years, get the last month of the year
              const lastMonth = Math.max(...items.map(item => item.month));
              return items.find(item => item.month === lastMonth);
          }
        });

        for (const period of filteredData) {
          const fairMarketValue = period.fairMarketValue;
          const grants = period.disbursements;
          const change = fairMarketValue - previousFMV;
          const grantsChange = grants - previousGrants;
          const avgAssets = (previousFMV + fairMarketValue) / 2.0;
          const percentChange =
            fairMarketValue != 0.0 ? (change / (fairMarketValue - change)) * 100.0 : 0.0;
          const grantsPercentChange =
            grants != 0.0 ? (grantsChange / (grants - grantsChange)) * 100.0 : 0.0;

          const grantsAsPercentageOfAssets =
            fairMarketValue != 0.0 ? (grants / avgAssets) * 100.0 : 0.0;

          previousFMV = fairMarketValue;
          previousGrants = grants;
          if (period.fiscalYear > 2008) {
            data.push({
              period: period.indexDate,
              fairMarketValue,
              change,
              percentChange,
              grants,
              grantsPercentChange,
              grantsChange,
              grantsAsPercentageOfAssets,
            });
          }
        }

        data = data.reverse();
        this.setState({ data, stateLabel, city, state, county, zip });
      });
  }

  public round(numberToRound: number, precision: number) {
    return (Math.round(numberToRound * 10) / 10).toFixed(precision);
  }

  public wrapNumberInParenthesis(
    number: number,
    prefix: string,
    suffix: string
  ) {
    const roundedNumber = this.roundNumber(number, 1, true);
    return number < 0
      ? "(" + prefix + roundedNumber + suffix + ")"
      : prefix + roundedNumber + suffix;
  }

  public roundNumber(number, precision, absolute: boolean) {
    return parseFloat(
      this.round(
        parseFloat((number * (absolute && number < 0 ? -1.0 : 1.0)).toFixed(1)),
        1
      )
    ).toLocaleString(undefined, { minimumFractionDigits: precision });
  }

  render() {
    const { data, city, county, zip } = this.state;
    const { state } = this.props;
    // const stateLabel = "";
    const stateLabel = (state && state.stateLabel); // || (this.state && this.state.state && this.state.state.stateLabel) || 'U.S.'

    const title =
      city !== ""
        ? city
        : county !== ""
          ? county
          : stateLabel !== ""
            ? stateLabel
            : zip !== ""
              ? zip
              : "U.S.";
    return (
      <section>
        <header style={{ padding: "10px", fontSize: "1.8rem" }}>
          {title} Assets and Grants
        </header>
        <small style={{ padding: "10px" }}>$ in millions</small>
        <Table responsive striped>
          <thead>
            <tr>
              <th className="text-center" style={{ width: "14%" }}>
                Period
              </th>
              <th className="text-center" style={{ width: "14%" }}>
                Assets
              </th>
              <th className="text-center" style={{ width: "14%" }}>
                Change
              </th>
              <th className="text-center" style={{ width: "14%" }}>
                % Change
              </th>
              <th
                className="text-center"
                style={{ width: "14%", borderLeft: "2px solid #ddd" }}
              >
                Grants and Expenses&#42;&nbsp;
              </th>
              <th className="text-center" style={{ width: "14%" }}>
                Grants and Expenses % Change
              </th>
              <th className="text-center" style={{ width: "14%" }}>
                Grants as % of Average Total Assets
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((object, index) => {
              return (
                <tr key={object.period + index}>
                  <td className="text-center">{object.period}</td>
                  <td className="text-center">
                    ${this.roundNumber(object.fairMarketValue, 1, false)}
                  </td>
                  <td className="text-center">
                    {this.wrapNumberInParenthesis(object.change, "$", "")}
                  </td>
                  <td className="text-center">
                    {this.wrapNumberInParenthesis(
                      object.percentChange,
                      "",
                      "%"
                    )}
                  </td>
                  <td
                    className="text-center"
                    style={{ borderLeft: "2px solid #ddd" }}
                  >
                    ${this.roundNumber(object.grants, 1, false)}
                  </td>
                  <td className="text-center">
                    {object.period === "Dec, 2009"
                      ? "---"
                      : this.wrapNumberInParenthesis(
                        object.grantsPercentChange,
                        "",
                        "%"
                      )}
                  </td>
                  <td className="text-center">
                    {this.roundNumber(
                      parseFloat(object.grantsAsPercentageOfAssets),
                      1,
                      false
                    )}
                    %
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div
          style={{
            height: "400px",
            overflow: "auto",
            padding: "10px",
            fontWeight: "bold",
          }}
        >
          &#42;&nbsp;The data used to calculate the asset and grantmaking charts
          above is a combination of historical data pulled from foundations
          public filings, typically with about a 1 year time lag and estimates
          for more recent periods. Asset value estimates are calculated using
          the GIV index as a proxy for foundation investment performance.
          Grantmaking expectations are shown annualized and calculated using
          historical payout ratios. All data is subject to revisions and actual
          results may be materially different from the estimates shown.
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/AssetAndGrantsTable/index.tsx